module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud_v2.b0bfc91d0102f5961680553863f8facf.png";